import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-live_play",
  "use": "icon-live_play-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-live_play\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path d=\"M18 33C9.716 33 3 26.285 3 18 3 9.716 9.716 3 18 3c8.285 0 15 6.716 15 15 0 8.285-6.715 15-15 15Zm-2.067-20.377a.6.6 0 0 0-.933.498v9.758a.6.6 0 0 0 .933.498l7.319-4.877a.6.6 0 0 0 0-1l-7.32-4.877h.001Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol